<script lang="ts">
	export let title: string;
</script>

<div
	class="flex justify-center items-center gap-3 text-fx-grey-300 font-semibold text-center rounded-xl squircle-xl bg-fx-grey-600 py-3 sm:py-4 cursor-not-allowed text-xs sm:text-sm w-full"
>
	<span>{title}</span>
</div>
